module.exports = __webpack_public_path__ + "img/point_starting_w.c8d7d01a.svg";